// faq
$(function () {

  var coll = document.getElementsByClassName('open')
  var i

  for (i = 0; i < coll.length; i++) {
    coll[i].addEventListener('click', function () {
      this.classList.add('is-active')
      var content = this.previousElementSibling
      var close = this.nextElementSibling
      close.classList.toggle('is-show')

      if (content.style.maxHeight) {
        content.style.maxHeight = null
      } else {
        content.style.maxHeight = content.scrollHeight + 'px'
      }

      close.addEventListener('click', function () {
        content.style.maxHeight = null
        this.classList.remove('is-show')
        this.previousElementSibling.classList.remove('is-active')
      })
    })
  }

  var faq = document.getElementsByClassName('lp10-faq__list-title')

  for (i = 0; i < faq.length; i++) {
    faq[i].addEventListener('click', function () {
      this.classList.toggle('is-active')
      var content = this.nextElementSibling
      if (content.style.maxHeight) {
        content.style.maxHeight = null
      } else {
        content.style.maxHeight = content.scrollHeight + 'px'
      }
    })
  }

})

// smooth scroll
$(function(){

  $(".js-smooth-scroll").on("click", function(event) {
    event.preventDefault();
    var target = $(this).attr("href");
    var position = $(target).offset().top;
    var gap = 30
    $("html, body").animate({ scrollTop: position - gap }, 800);
  });

});

// float button
$(function(){

  $(window).on('scroll', function() {
    var scrollPosition = $(window).scrollTop();
    var floatBtn = $(".lp10-float-btn");
    var gap = $(window).height() / 2;

    var rangeIds = ["LP10-MV", "LP10-SEC12"];

    $.each(rangeIds, function(index, rangeId) {
      var range = $("#" + rangeId);
      if (range.length) {
        var start = range.offset().top - gap;
        var end = start + range.outerHeight() - gap;
  
        if (scrollPosition >= start && scrollPosition <= end) {
          floatBtn.addClass("hide");
          return false; // 範囲内であれば処理終了
        } else {
          floatBtn.removeClass("hide");
        }
      }
    });
  });

});